// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2zn5V","unreadBadge":"styles_unreadBadge__1H7Ca","modalContent":"styles_modalContent__dX_xa","modal":"styles_modal__2Nuz7"};